import { render, staticRenderFns } from "./ServiceItemModal.vue?vue&type=template&id=f52d8aa6&lang=pug"
import script from "./ServiceItemModal.vue?vue&type=script&lang=js"
export * from "./ServiceItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports